import Cookie from "../utils/Cookie";
import Constants from "./ConstantParameter";

export default {
  getCampaignParameter(): CampaignParamType {
    const campaign: CampaignParamType = {};

    Constants.COOKIE.CAMPAIGN.map(key => {
      const objKey = key.replace(/^trac_/, '');
      const value = Cookie.getCookie(key).replace(/"/g, '');
      campaign[objKey as keyof typeof campaign] = (value !== "0") && value || '';
    });

    return campaign['src'] && campaign['spec'] && {
      campaign
    } || {};
  }
}
